import _CircularProgress from "@material-ui/core/esm/CircularProgress";
import _Backdrop from "@material-ui/core/esm/Backdrop";
import _Box from "@material-ui/core/esm/Box";
import _Typography from "@material-ui/core/esm/Typography";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import PropTypes from 'prop-types';
import { useLoader } from "./hooks/useLoader";
import { useStyles } from "./LoaderStyles";

var _ref = /*#__PURE__*/_jsx(_CircularProgress, {
  color: "inherit",
  size: 56
});

const Loader = props => {
  const children = props.children,
        topText = props.topText,
        bottomText = props.bottomText;
  const classes = useStyles();

  const _useLoader = useLoader(),
        show = _useLoader.show,
        texts = _useLoader.texts;

  const textRender = text => text ? _jsx(_Box, {
    m: 4
  }, void 0, _jsx(_Typography, {
    variant: "h5"
  }, void 0, text)) : null;

  return _jsx(_Backdrop, {
    open: show || false,
    className: classes.backdrop
  }, void 0, children ? children : React.createElement(React.Fragment, null, textRender(topText || texts.topText), _ref, textRender(bottomText || texts.bottomText)));
};

export { Loader };